import { Skeleton } from '@mui/material';

import { useRowEnrichment } from '../row-enrichment';
import type { ResourceRow } from '../types';

/**
 * The transcription list's Notes column (GDN-2731).
 *
 * A component rather than an inline render function because it reads context,
 * which needs a real component boundary.
 *
 * "Loading" and "zero" are shown differently on purpose. Zero is the answer
 * operators are scanning for — a transcript that produced no note — so
 * rendering 0 while the count is still in flight would assert a failure that
 * may not exist.
 */
export function NoteCountCell({ row }: { row: ResourceRow }) {
  const id = typeof row.id === 'string' ? row.id : '';
  const { value, isLoading } = useRowEnrichment<number>(id);

  if (isLoading) return <Skeleton variant="text" width={24} />;
  if (typeof value !== 'number') return <span className="text-gray-400">—</span>;

  return (
    <span className={value === 0 ? 'font-medium text-amber-700' : undefined}>
      {value}
    </span>
  );
}
